module.exports = __webpack_public_path__ + "img/workLogo.308ac297.png";